<template>
    <v-container>
        <h1 class="display-1">Detach User From Campaign {{ campaign.title }}</h1>

        <v-card class="mt-4" v-for="(user, index) of users" :key="index">
            <v-card-title>{{ user.name }}</v-card-title>
            <v-card-actions>
                <v-btn class="ml-2 mb-2" color="primary" @click="detachUserFromCampaign(index)" :loading="loading">
                    Detach
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-btn @click="$router.push({name: 'campaign', params: {campaignId: $route.params.campaignId}})" class="mt-4">Back to Campaign</v-btn>
    </v-container>
</template>

<script>
  import CampaignService from "../services/CampaignService";

  export default {
    data: () => ({
      campaign: {
        id: null,
        title: null
      },
      users: [{
        id: null,
        name: null
      }],
      loading: false
    }),

    created() {
      this.viewCampaign();
      this.indexUsers();
    },

    methods: {
      viewCampaign() {
        CampaignService.view(this.$route.params.campaignId)
          .then(response => {
            this.campaign = response.data.data;
          })
          .catch(() => {
            this.$router.push({name: "home"});
          });
      },

      indexUsers() {
        CampaignService.indexAttachedUsers(this.$route.params.campaignId)
          .then(response => {
            this.users = response.data.data;
          });
      },

      detachUserFromCampaign(index) {
        if (this.users[index].id === null || this.campaign.id === null) {
          return;
        }

        this.loading = true;

        CampaignService.detachUser(this.campaign.id, this.users[index].id)
          .then(() => {
            this.users.splice(index, 1);
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          })
      }
    }
  };
</script>
